<div class="banner-container">
  <div class="banner-image-content" [style.height.px]="bannerImageHeight" [style.max-width.px]="maxBannerWidth">
    <img src={{bannerImage}} alt="image">
  </div>
  <div class="banner-info-container" #contentRef [style.height.px]="bannerContentHeight">
    <div class="banner-content">
      <div class="banner-info-title" [innerHTML]="safeTitle" #titleRef></div>

      <div 
        *ngIf="customerBannerData?.contentText"
        class="banner-info"
        [ngStyle]="infoStyle"
        [innerHTML]="safeContent" #infoRef></div>
    </div>

    <div class="btn-action-container" *ngIf="customerBannerData?.hyperLinkUrl"  #btnRef>
      <button
        class="btn mapfre basic primary large-btn"
        [ngStyle]="buttonStyle"
        (click)="onClick(customerBannerData?.learnMoreGALabel)"
        id="paperless-enroll-in-papers"
        [style.width]="customerBannerData?.hyperLinkWidth"
      >
          {{ customerBannerData?.hyperLinkText }}
      </button>
    </div>  
  </div>
</div>